import { CustomApiException } from '@/modules/core/app/models/CustomApiException';

export class InvalidCompanyDomainException extends CustomApiException {
  constructor(model: Partial<InvalidCompanyDomainException> = {}) {
    super(model);
  }
}
